import { defineComponent as _defineComponent } from 'vue'
import { normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, renderSlot as _renderSlot, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { ref, onMounted, onBeforeUnmount } from 'vue'
import { wait } from '@/plugins/utils'


export default /*#__PURE__*/_defineComponent({
  emits: ['update:modelValue'],
  setup(__props, { emit }) {



const el = ref()
const ob = new IntersectionObserver((entries) => {
  entries.forEach((tar) => {
    emit('update:modelValue', !tar.isIntersecting)
  })
})

onMounted(() => {
  ob && el.value && ob.observe(el.value)
})
onBeforeUnmount(() => {
  ob && el.value && ob.unobserve(el.value)
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _renderSlot(_ctx.$slots, "default", _normalizeProps(_guardReactiveProps(_ctx.$attrs))),
    _createElementVNode("div", {
      ref: (_value, _refs) => {
        _refs['el'] = _value
        el.value = _value
      }
    }, null, 512),
    _renderSlot(_ctx.$slots, "top", _normalizeProps(_guardReactiveProps(_ctx.$attrs)))
  ], 64))
}
}

})